import { Badge } from "@babackapp/ui/components/badge";

export type BackfillState = {
  collection: string;
  isDone: boolean;
  isPaused: boolean;
  total: number;
  scanned: number;
  recorded: number;
};

const COLLECTION_LABELS: Record<string, string> = {
  returnRequest: "Retours",
  parcel: "Colis",
  order: "Commandes",
};

const statusOf = (
  state: BackfillState,
): { label: string; variant: "default" | "secondary" | "outline" } => {
  if (state.isDone) return { label: "Terminé", variant: "secondary" };
  if (state.isPaused) return { label: "En pause", variant: "outline" };
  return { label: "En cours", variant: "default" };
};

const percentOf = (state: BackfillState): number =>
  state.total > 0
    ? Math.min(100, Math.round((state.scanned / state.total) * 100))
    : 0;

export function PiiBackfillProgress({ state }: { state: BackfillState }) {
  const percent = percentOf(state);
  const status = statusOf(state);

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between text-sm">
        <span className="font-medium">
          {COLLECTION_LABELS[state.collection] ?? state.collection}
        </span>
        <div className="flex items-center gap-2">
          <span className="text-muted-foreground tabular-nums">
            {state.scanned.toLocaleString("fr-FR")} /{" "}
            {state.total.toLocaleString("fr-FR")}
          </span>
          <Badge variant={status.variant} size="xs">
            {status.label}
          </Badge>
        </div>
      </div>
      <div className="h-2 w-full rounded bg-muted">
        <div
          className="h-2 rounded bg-emerald-500 transition-all"
          style={{ width: `${percent}%` }}
        />
      </div>
      <p className="text-xs text-muted-foreground">
        {state.recorded.toLocaleString("fr-FR")} document(s) écrits dans le
        coffre
      </p>
    </div>
  );
}
